import { createFileRoute } from "@tanstack/react-router";
import { CodeBrowser } from "@/faults-app/components/code-browser";

export const Route = createFileRoute("/vfd-codes")({
  head: () => ({
    meta: [
      { title: "رموز أعطال VFD والإنفرترات الصناعية" },
      {
        name: "description",
        content:
          "قاعدة بيانات عربية لرموز أعطال أجهزة الـVFD حسب الشركة والموديل: المعنى، السبب، خطوات الفحص، الحلول والأجزاء المشتبهة.",
      },
      { property: "og:title", content: "رموز أعطال VFD والإنفرترات الصناعية" },
      {
        property: "og:description",
        content: "ابحث عن رمز عطل الدرايف حسب الشركة والموديل واحصل على خطوات الفحص والحل.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
  }),
  component: VfdCodes,
});

function VfdCodes() {
  return (
    <CodeBrowser
      domain="vfd"
      title="رموز أعطال VFD"
      subtitle="اختر الشركة ← الموديل ← رمز العطل"
      brandLabel="الشركة المصنعة"
      searchPlaceholder="مثال: OC أو F001 أو ABB"
    />
  );
}
